<!-- 客服咨询 -->
<template>
    <div class="customerService">
        <div class="chat_contain">
            <div class="chat_item_left">
                <div class="use_img">
                    <img data-v-41e721c3="" src="../assets/images/wx2.png">
                </div>
                <div class="flexitem">
                    <div class="name_user">
                        系统 今天 {{time}}
                    </div>
                    <div class="message_content">
                        <div class="title">hi ！亲,非常荣幸与您相遇在这里，我是您的专属客服,竭诚为您服务!请问您要咨询什么问题呢？</div>
                        <ul class="menu_content_list">
                            <li v-for="(item,index) in queList" :key="item.label" @click="handleList(item, index)">
                                {{index+1}} <span class="link">{{item.label}}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <template  v-for="(item) in chooseList">
            <div class="block-1" :key="item.id">
                <!-- 没收到商品 -->
                <div class="chat_contain">
                    <div class="chat_item_right">
                        <div class="use_img">
                            <img data-v-41e721c3="" src="../assets/images/124.png">
                        </div>
                        <div class="flexitem">
                            <div class="name_user">我 今天 {{time}}</div>
                            <div class="message_content">
                                <div class="title">{{item.label}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="chat_contain">
                    <div class="chat_item_left">
                        <div class="use_img">
                            <img data-v-41e721c3="" src="../assets/images/wx2.png">
                        </div>
                        <div class="flexitem">
                            <div class="name_user">
                                系统 今天 {{time}}
                            </div>
                            <div class="message_content">
                                <div class="title">{{item.value}}</div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        

    </div>
</template>
<script>
export default {
    data() {
        return {
            queList: [
                {
                    id: 1,
                    label: '没收到商品（快币）',
                    value: '亲，订单支付成功后，一般1分钟内自动充值到账，高峰时间可能需要排队如超过30分钟未到账请及时联系客服咨询',
                },
                {
                    id: 2,
                    label: '没有想要的面额',
                    value: '亲，目前官方只支持以上几种面额充值，您可以选择合适的面额多次购买哈~',
                },
                {
                    id: 3,
                    label: '价格太贵了',
                    value: '我们是对接了官方充值系统，保障正品，不封号。为了给用户提供更加便捷的服务，我们提供最优惠的充值比例，同时收取少量手续费哦',
                },
                {
                    id: 4,
                    label: '怎么退款',
                    value: '亲若您的订单充值完毕则无法退款!若在两小时内未到账，官方会申请退款，预计5-7个工作日原路退回非常抱歉给您带来不好的体验',
                }
            ],
            chooseList: [],
            time: '',
            currIndex: '',
        }
    },
    created() {
        const _d = new Date();
        this.time = _d.getHours() +':'+ _d.getMinutes();
    },
    methods: {
        handleList(item,idx) {
            const _d = new Date();
            this.time = _d.getHours() +':'+ _d.getMinutes();

            const isExit = this.chooseList.some(prop=> prop.id === item.id);
            if(!isExit) {
                this.chooseList.push(item);
                this.toPageBottom();
                
            }
        },
        toPageBottom() {
            
            setTimeout(() => {
                const _h = document.documentElement.scrollHeight;
                console.log(_h);
                window.scrollTo(0, _h);
            }, 300);
            
        }
    },
}
</script>
<style>
    body {
    background: #f2f2f2;
}
</style>
<style lang="less" scoped>

   .customerService {
    padding-bottom: 20px;
    .chat_contain {
        .chat_item_left {
            display: flex;
            padding-top: 18px;
            .use_img {
                margin: 10px;
                img {
                    border-radius: 5px;
                    height: 40px;
                    width: 40px;
                }
            }
            .flexitem {
                width: 75%;
                position: relative;
                .name_user {
                    color: #999;
                    margin-bottom: 3px;
                }
                .message_content {
                    padding: 10px;
                    background: #fff;
                    border-radius: 5px;
                    .title {

                    }
                    .menu_content_list {
                        padding: 10px 5px;
                        li {
                            margin-bottom: 6px;
                        }
                        .link {
                            color: #1890ff;
                        }
                    }
                }
            }
        }
        .chat_item_right {
            flex-direction: row-reverse;
        }

        .chat_item_right {
            display: flex;
            padding-top: 18px;
            flex-direction: row-reverse;
            .use_img {
                margin: 10px;
                img {
                    border-radius: 5px;
                    height: 40px;
                    width: 40px;
                }
            }
            .flexitem {
                width: 75%;
                position: relative;
                text-align: right;
                .name_user {
                    color: #999;
                    margin-bottom: 3px;
                    text-align: right;
                }
                .message_content {
                    .title {
                        display: inline-block;
                        padding: 12px 10px;
                        background: #a0e75a;
                        border-radius: 5px;
                    }
                    .menu_content_list {
                        padding: 10px 5px;
                        li {
                            margin-bottom: 6px;
                        }
                        .link {
                            color: #1890ff;
                        }
                    }
                }
            }
        }
    }
   } 
</style>